import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.css']
})
export class UserDetailsComponent implements OnInit {
  @Input('customerValues') customerValues: any;
   constructor() { }

  ngOnInit(): void {
  }
  
  // Current Date and Time
     curDate=new Date();

      // Random Serial Number
      serialNumber = Math.floor((Math.random() * 10000) + 1);
     
  }
